import { cn } from "@/lib/utils";

export const ToolText = ({ children, className }: { children: string; className?: string }) => (
  <span className={cn("text-xs font-medium leading-5 tracking-normal", className)}>{children}</span>
);
